import axios from "axios";
import {
  BASE_PROMPT,
  BASE_SYSTEM_PROMPT,
  buildUserContent,
  PdfExcerpt,
  RunPromptOptions,
  RunPromptResult,
} from "./aiCommon";
import { Reference } from "./reference";

/**
 * Call an OpenAI Chat model (default: gpt-5) with a base prompt and PDF excerpts.
 * Requires OPENAI_API_KEY in environment.
 */
export async function runPromptOpenAi(
  sourceDocument: PdfExcerpt,
  reference: Reference,
  options: RunPromptOptions = {}
): Promise<RunPromptResult> {
  const apiKey = process.env.OPENAI_API_KEY;
  if (!apiKey) throw new Error("OPENAI_API_KEY env var is required");

  // const model = options.model || "gpt-5-nano";
  // const model = options.model || "gpt-5-mini";
  const model = options.model || "gpt-5";
  const temperature =
    typeof options.temperature === "number" ? options.temperature : 1;
  const { maxTokens } = options;
  const systemMessage = options.system || BASE_SYSTEM_PROMPT;

  const basePrompt = BASE_PROMPT;

  const maxInputChars = options.maxInputChars || 160000; // soft guardrail (~160k chars)
  const { content: built, truncated } = buildUserContent(
    basePrompt,
    sourceDocument,
    reference,
    maxInputChars
  );
  // OpenAI path stays text-only; ignore attached images if present.
  const userContent =
    typeof built === "string"
      ? built
      : built
          .filter((p): p is { type: "text"; text: string } => p.type === "text")
          .map((p) => p.text)
          .join("\n");

  const payload = {
    model,
    temperature,
    max_tokens: maxTokens,
    messages: [
      { role: "system", content: systemMessage },
      { role: "user", content: userContent },
    ],
  };

  // console.log("payload for ", sourceDocument.fileName, payload);

  const { data } = await axios.post(
    "https://api.openai.com/v1/chat/completions",
    payload,
    {
      headers: {
        Authorization: `Bearer ${apiKey}`,
        "Content-Type": "application/json",
      },
      timeout: 720000,
    }
  );

  const choice = data?.choices?.[0];
  const text: string = choice?.message?.content || "";

  // console.log("got response for ", sourceDocument.fileName);

  return {
    text,
    fileName: sourceDocument.fileName,
    model: data?.model || model,
    usage: data?.usage,
    raw: data,
    reference,
    ...(truncated ? { inputTruncated: true } : {}),
  };
}
export default runPromptOpenAi;
